import { useEffect, useRef, useState } from "react";
import { del, get, post } from "./api";

export default function useFavorites(enabled, identity) {
  const [favoriteProductIds, setFavoriteProductIds] = useState([]);
  const requestVersion = useRef(0);

  useEffect(() => {
    if (!enabled) {
      setFavoriteProductIds([]);
      return undefined;
    }

    const version = ++requestVersion.current;
    get("/customers/me/favorites/products")
      .then((response) => {
        if (version === requestVersion.current) {
          setFavoriteProductIds((response.favoriteProductIds || []).map(String));
        }
      })
      .catch(() => {
        if (version === requestVersion.current) setFavoriteProductIds([]);
      });

    return () => {
      requestVersion.current += 1;
    };
  }, [enabled, identity]);

  const toggleFavorite = async (productId) => {
    if (!enabled) throw new Error("Sign in as a customer to save favorites.");
    const id = String(productId);
    const isFavorite = favoriteProductIds.includes(id);
    requestVersion.current += 1;

    const response = isFavorite
      ? await del(`/customers/me/favorites/products/${encodeURIComponent(id)}`)
      : await post(`/customers/me/favorites/products/${encodeURIComponent(id)}`, {});
    const responseIds = (response.favoriteProductIds || []).map(String);
    setFavoriteProductIds((currentIds) => {
      const nextIds = new Set(currentIds);
      if (isFavorite) nextIds.delete(id);
      else nextIds.add(id);
      return Array.from(nextIds);
    });
    window.dispatchEvent(new Event("favorites-updated"));
    return responseIds.includes(id) === !isFavorite;
  };

  return { favoriteProductIds, toggleFavorite };
}
